var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFillSystemsArrowGoBackFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2599_108698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 9.33337V14.6667L2.6665 8.00004L10.6665 1.33337V6.66671H17.3332C20.1621 6.66671 22.8753 7.79051 24.8756 9.7909C26.876 11.7913 27.9998 14.5044 27.9998 17.3334C27.9998 20.1623 26.876 22.8755 24.8756 24.8758C22.8753 26.8762 20.1621 28 17.3332 28H5.33317V25.3334H17.3332C19.4549 25.3334 21.4897 24.4905 22.99 22.9902C24.4903 21.4899 25.3332 19.4551 25.3332 17.3334C25.3332 15.2116 24.4903 13.1768 22.99 11.6765C21.4897 10.1762 19.4549 9.33337 17.3332 9.33337H10.6665Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2599_108698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillSystemsArrowGoBackFill);
export default __webpack_public_path__ + "static/media/Fill__Systems--arrow-go-back-fill.46913bb7e110adea6b3b0449e5bf2eaa.svg";
export { ForwardRef as ReactComponent };